import React from "react";

const RenderCardTitle = ({
  editInfo,
  pickupIndex,
  classes,
  pickupIdToNumberMap,
  packagingSummaryItems,
}) => {
  const { pickupId, proNumber } = editInfo ?? {};
  const pickupNumber = pickupIdToNumberMap[pickupId];
  return (
    <div className={classes.cardTitleContainer}>
      <div>
        <div className={classes.cardTitlePickupNumber}>
          PRO# <span>{proNumber}</span>
        </div>
        <div className={classes.cardProInfo}>
          {packagingSummaryItems.map(({ key, label, value }) => (
            <React.Fragment key={key}>
              {label}
              <span className={classes.cardProInfoValue}>{value}</span>
            </React.Fragment>
          ))}
        </div>
      </div>
      <div className={classes.cardTitleProDetails}>
        <div className={classes.cardTitleProDetailsIndex}>
          PRO <span>{pickupIndex}</span>
        </div>
        <div>
          PICKUP # <span>{pickupNumber}</span>
        </div>
      </div>
    </div>
  );
};

export default RenderCardTitle;
